export default __webpack_public_path__ + "static/media/logo-animated.3404de32.svg";